import './highlight-full-width.scss'

import React from 'react'

import Button from '@/components/button/button'
import Image from '@/components/image/image'
import TitleLink from '@/components/title-link/title-link'
import useDefaultImages from '@/hooks/useDefaultImages'
import { generateUrl } from '@/internal/utils/generate-url'

type Props = {
  __typename:
    | 'DatoCmsPctPost'
    | 'DatoCmsPctProject'
    | 'DatoCmsPctPage'
    | 'DatoCmsPctPaper'
    | 'DatoCmsPctDialog'
    | 'DatoCmsPctEpisode'
    | 'DatoCmsPctExternalContent'
  image: Queries.imgHighlightFullWidthFragment | null
  title: string | null
  topic: Queries.TopicReferenceFragment | null
  link: string
  excerpt: string | null
  footer?: string
}

const HighlightFullWidth: React.FC<Props> = ({
  __typename,
  image,
  title,
  topic,
  link,
  excerpt,
  footer
}) => {
  const { imgHighlightFullWidth } = useDefaultImages(__typename) ?? {}
  const imageBackground =
    image?.gatsbyImageData ?? imgHighlightFullWidth?.desktop
  return (
    <div className="big-highlight">
      <div className="text-with-image">
        {imageBackground && (
          <Image
            image={image?.gatsbyImageData ?? imgHighlightFullWidth.desktop}
            alt={title ?? ''}
          />
        )}
        <div className="container-text">
          <div className="container">
            {topic?.slug && (
              <div className="row text-center">
                <div className="topic">
                  <Button
                    to={generateUrl('DatoCmsPctTopic', topic?.slug)}
                    title={topic?.externalName}
                    isBgDark
                  />
                </div>
              </div>
            )}
            <div className="row text-center justify-content-center">
              <div className="col-lg-10">
                <TitleLink to={link} title={title ?? ''} isWhite />
              </div>
              <div className="col-lg-8 mt-lg-4">
                <p className="description">{excerpt}</p>
              </div>
            </div>
            {footer && (
              <div className="row">
                <div className="col text-center author">{footer}</div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default HighlightFullWidth
